import { render, staticRenderFns } from "./ChatGroups.vue?vue&type=template&id=7a307466&"
import script from "./ChatGroups.vue?vue&type=script&lang=ts&"
export * from "./ChatGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports